import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="39" height="40" viewBox="0 0 39 40" fill="none">
    <g clipPath="url(#clip0_1247_1919)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.1834 11.5444C29.4891 13.0111 30.9423 14.6434 32.1787 16.7728C33.6421 19.3072 34.3534 21.8642 34.3534 24.5902C34.3534 32.8115 27.6921 39.4999 19.5045 39.4999C11.3229 39.4999 4.66546 32.8213 4.65579 24.6083C4.40282 16.364 9.39071 11.7033 9.60338 11.5088C10.3125 10.86 11.4569 11.3239 11.5144 12.2835C11.515 12.2929 11.6073 13.5928 12.2475 15.0609C12.7417 16.1942 13.4126 17.109 14.2519 17.7975C13.9973 15.1227 14.204 12.6567 14.8708 10.4423C15.567 8.13015 16.7594 6.09423 18.4149 4.39126C21.2255 1.5 24.3943 0.58175 24.5278 0.544044C25.3715 0.306007 26.1577 1.06811 25.9464 1.9191C25.9336 1.97196 24.6396 7.48513 27.9492 11.2812C28.0267 11.3684 28.1048 11.4561 28.1834 11.5444ZM15.3449 21.3693C14.3616 21.3693 13.5645 22.0701 13.5645 22.9345C13.5645 23.799 14.3616 24.4997 15.3449 24.4997C16.3282 24.4997 17.1253 23.7989 17.1253 22.9345C17.1253 22.0701 16.3282 21.3693 15.3449 21.3693ZM15.0224 34.1895C15.8655 34.6342 16.9593 34.3939 17.4651 33.6526L24.5869 23.2182C25.0928 22.477 24.8194 21.5155 23.9762 21.0708C23.1331 20.6261 22.0393 20.8664 21.5334 21.6077L14.4117 32.0421C13.9058 32.7833 14.1792 33.7448 15.0224 34.1895ZM21.8731 32.3256C21.8731 33.19 22.6703 33.8907 23.6536 33.8907C24.6369 33.8907 25.434 33.1901 25.434 32.3256C25.434 31.4612 24.6369 30.7604 23.6536 30.7604C22.6703 30.7604 21.8731 31.4612 21.8731 32.3256Z"
        fill="url(#paint0_linear_1247_1919)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1247_1919"
        x1="19.4999"
        y1="39.4999"
        x2="19.4999"
        y2="0.499943"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#100C0B" />
        <stop offset="1" stopColor="#541400" />
      </linearGradient>
      <clipPath id="clip0_1247_1919">
        <rect
          width="39"
          height="39"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
));
